export class PrintComponentConfig {
	data?: any;
}
